import { auth, db, fieldValue } from "./firebase.utils";
const TOKEN_KEY = "antlogy-browser-push-token";
const pending = new Set();
let signingOut = false;

export function registerBrowserToken(uid, getToken, type) {
  const operation = (async () => {
    if (signingOut || auth.currentUser?.uid !== uid) return;
    const token = await getToken();
    if (!token || signingOut || auth.currentUser?.uid !== uid) return;
    // Save first so sign-out can also clean up after an interrupted registration.
    localStorage.setItem(TOKEN_KEY, token);
    await db.collection("fcmTokens").doc(token).set({
      user: uid, type, timestamp: fieldValue.serverTimestamp(),
    }, { merge: true });
    return token;
  })();
  pending.add(operation);
  operation.then(() => pending.delete(operation), () => pending.delete(operation));
  return operation;
}

export async function signOutWithNotifications() {
  if (signingOut) return false;
  signingOut = true;
  try {
    const uid = auth.currentUser?.uid;
    await Promise.allSettled([...pending]);
    const token = localStorage.getItem(TOKEN_KEY);
    if (uid && token) {
      // The query is owner-scoped: another device's registration is untouched.
      const rows = await db.collection("fcmTokens").where("user", "==", uid).get();
      await Promise.all(rows.docs.filter((d) => d.id === token).map((d) => d.ref.delete()));
    }
    localStorage.removeItem(TOKEN_KEY);
    await auth.signOut();
    return true;
  } catch (error) {
    console.error("Sign out:", error);
    window.alert("Could not sign out. Please check your connection and try again.");
    return false;
  } finally { signingOut = false; }
}
